import { InjectionToken } from '@angular/core';

/**
 * Opens the "new LIL inspection" picker when the workspace FAB dispatches the `cil-new` menu
 * entry. The host app provides its CIL inspection modal service (`CilNewInspectionModalService`), whose
 * `openNewInspection()` matches this contract.
 *
 * Build-graph isolation (see `.claude/rules/lazy-import-does-not-isolate-build-graph.md`):
 * `FloatAddButtonModule` is compiled by every app that uses `SvcPrivateLayoutComponent`, while
 * `@solvace/feature/modals/svc-modal-cil-setup` is built only by `cil`, `notification` and
 * `myworkspace`. Importing the CIL modal service here, even lazily, would add the CIL modal
 * subtree to ~20 builds that never render it. Without a provider the dispatcher returns `false`
 * and the FAB falls back to `router.navigate(['/cil-new'])`.
 */
export interface WorkspaceCilInspectionOpener {
  openNewInspection(): void;
}

export const WORKSPACE_CIL_INSPECTION_OPENER = new InjectionToken<WorkspaceCilInspectionOpener>('WORKSPACE_CIL_INSPECTION_OPENER');
